<template>
    <div>
        <h2>Scratch Hjælp</h2>
        <p>Her kan du finde svar på de mest almindelige problemer. <br>
        Hvis du ikke kan finde svar på dit problem her, så søg hjælp på Scratch.</p>
      
        <div class="vids">
          <EmbedYoutube id="98oHJs_naSI" title="Bevæger din karakter sig ikke som den skal?<br>Få hjælp her." />
          <EmbedYoutube id="ripFdQWpWAA" title="Vender din karakter på hovedet?<br>Få hjælp her." />
          <EmbedYoutube id="oFimV14imPs" title="Når koden er rigtig, men det alligevel ikke virker. <br> Centrering af skud." />
          <EmbedYoutube id="PWcpdxYBPxw" title="Skift baggrund når du har x antal point." /> 
          <EmbedYoutube id="Ndwp-Q7m0zE" title="Tryk på ‘Explore’ på Scratch for at finde inspiration og hjælp til at kode dit spil." />
          <EmbedYoutube id="gYGtWkk49xk" title="Søg på alt i hele verden på Scratch, for at få inspiration og hjælp til at kode dit spil." />
          <EmbedYoutube id="Ox1-8eDZfnc" title="Søg på 'mettemush' på Scratch, for at finde inspiration og hjælp til at kode dit spil." />
          
        </div>
    </div>
</template>

<script>
import EmbedScratch from '@/components/ScratchEmbed';
import EmbedYoutube from '@/components/YoutubeEmbed';
export default {
  name: 'Links',
  components: {
    EmbedScratch,
    EmbedYoutube
  }
}
</script>


<style>
  .vids {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .vids .yt-video {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 340px;
    width: 470px;
  }
  .vids .yt-video {
    text-align: center;
    font-size: 15px;    
   }
   .vids .yt-video h3 { 
     width: 100%;
   }
  .vids .yt-video .play {
    position: relative;
    height: 264px;
    width: 470px;
    margin: 0 auto;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/tips-og-tricks/scratch-help.vue